import { DisciplineSchedule } from '../../Components/DisciplineSchedule';

export const BowlingPinMatchSchedule = () => {
  return (
    <DisciplineSchedule 
      discipline="BOWLING_PIN_MATCH" 
      disciplineName="Bowling Pin Match"
    />
  );
};
